const atualizarPedidosAvulso = (state, pedidosAvulso) => {
    state.pedidosAvulso = pedidosAvulso;
}

const atualizarPedidoAvulso = (state, pedidoAvulso) => {
    state.pedidoAvulso = pedidoAvulso;
}

const updatePedidoAvulso = (state, pedidoAvulso) => {
    const item = state.pedidosAvulso.find(item => item.id === pedidoAvulso.id);

    if (item) {
        Object.assign(item, pedidoAvulso);
    }
}

export default {
    atualizarPedidosAvulso,
    atualizarPedidoAvulso,
    updatePedidoAvulso
}
